module.exports = __webpack_public_path__ + "media/images/placeholder_phone-c4bc0a7a02f8b64b22178ef0501e44b5.png";